<template>
	<div class="container p-1">
		<div class="row space-between">
			<div class="col-3 col-md-3">
				<div class="row">
					<div class="col-12 col-md-12 akkurate-small">
						<table class="table table-bordered mb-0">
							<thead>
								<tr>
									<th colspan="2" scope="col" class="bg-dark">
										Payment & Repayment Status
									</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<!-- Field Name -->
									<td class="fw-bold">Status:</td>
									<!-- Field Value -->
									<td>{{ loan?.status }}</td>
								</tr>
								<tr>
									<!-- Field Name -->
									<td class="fw-bold">Tenure:</td>
									<!-- Field Value -->
									<td>{{ loan?.tenor }}</td>
								</tr>
								<tr>
									<td class="fw-bold">Tenure Interval:</td>
									<td>{{ loan?.tenor_interval }}</td>
								</tr>
								<tr>
									<td class="fw-bold">Interest Rate:</td>
									<td>
										{{ loan?.interest_rate }} /
										{{ loan?.interest_rate_frequency }}
									</td>
								</tr>

								<tr>
									<td class="fw-bold">Interest Method:</td>
									<td>{{ loan.interest_method }}</td>
								</tr>
								<tr>
									<td class="fw-bold">Interest Expected:</td>
									<td>
										{{ institution?.currency_code }}
										{{
											displayNumber(
												Number(
													loan.expected_interest
												).toFixed(2)
											)
										}}
									</td>
								</tr>
								<tr>
									<td class="fw-bold">Interest Balance:</td>
									<!-- <p class="mb-0">{{ loan.interest_balance - loan.interest_paid }}</p> -->
									<td style="color: #dc3545 !important">
										{{ institution?.currency_code }}
										{{
											displayNumber(
												Number(
													loan.interest_balance
												).toFixed(2)
											)
										}}
									</td>
								</tr>
								<tr>
									<td class="fw-bold">Interest Paid:</td>
									<td>
										{{ institution?.currency_code }}
										{{
											displayNumber(
												Number(
													loan.interest_paid
												).toFixed(2)
											)
										}}
									</td>
								</tr>
								<tr>
									<td class="fw-bold">Interest Due:</td>
									<td style="color: #3681c2 !important">
										{{ institution?.currency_code }}
										{{
											displayNumber(
												Number(
													loan.interest_due
												).toFixed(2)
											)
										}}
									</td>
								</tr>
								<tr>
									<td class="fw-bold">Payment Due:</td>

									<td style="color: #018673 !important">
										{{ institution?.currency_code }}
										{{ displayNumber(getDuePayment) }}
									</td>
								</tr>
								<!-- <div class="col-md-6"></div> -->
								<tr>
									<td class="fw-bold">Principal Paid:</td>
									<td>
										{{ institution?.currency_code }}
										{{
											displayNumber(
												Number(
													loan.principal_paid
												).toFixed(2)
											)
										}}
									</td>
								</tr>
								<!-- <div class="col-md-6"></div> -->
								<tr>
									<td class="fw-bold">Principal Bal:</td>
									<td style="color: #dc3545 !important">
										{{ institution?.currency_code }}
										{{
											displayNumber(
												Number(
													loan.principal_balance
												).toFixed(2)
											)
										}}
									</td>
								</tr>
								<!-- <div class="col-md-6"></div> -->
								<tr>
									<td class="fw-bold">Principal Due:</td>
									<td style="color: #3681c2 !important" class="fw-normal">
										{{ institution?.currency_code }}
										{{
											displayNumber(
												Number(
													loan.principal_due
												).toFixed(2)
											)
										}}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="col-3 col-md-3 akkurate-small">
				<div class="row h-100">
					<div class="col-md-12 mb-0 h-auto">
						<div class="row h-auto p-0 mb-0">
							<table class="table table-bordered p-0 mt-0 mb-0">
								<thead>
									<tr>
										<th colspan="2" scope="col">
											Disbursement & Repayment Terms
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td class="fw-bold">Repayment:</td>
										<td>{{ loan?.repayment_cycle }}</td>
									</tr>
									<tr>
										<td class="fw-bold">
											Number of Payment:
										</td>
										<td>{{ loan?.number_of_payment }}</td>
									</tr>
									<tr>
										<td class="fw-bold">Loan Type:</td>
										<td>
											{{ loan?.loan_product.name }}
										</td>
									</tr>
									<tr>
										<td class="fw-bold">
											Disbursement Date:
										</td>
										<td>
											{{ loan?.disbursed_loans?.trans_date }}
										</td>
									</tr>
									<tr>
										<td class="fw-bold">
											Interest Start Date:
										</td>
										<td>
											{{ loan?.interest_start_date }}
										</td>
									</tr>
									<tr>
										<td class="fw-bold">Maturity Date:</td>
										<td>
											{{ loan?.maturity_date }}
										</td>
									</tr>
									<tr>
										<td class="fw-bold">
											Loan Premium Plan:
										</td>
										<td>
											{{ institution?.currency_code }}
											{{ displayNumber(loan?.lpp_value) }}
										</td>
									</tr>
									<tr>
										<td class="fw-bold">
											Other Loan Charges:
										</td>
										<td>
											{{ institution?.currency_code }}
											{{
												displayNumber(
													loan?.other_charges
												)
											}}
										</td>
									</tr>
									<tr>
										<td class="fw-bold">
											Principal Disbursed:
										</td>
										<td>
											{{ institution?.currency_code }}
											{{
												displayNumber(
													Number(
														loan.principal_amount
													).toFixed(2)
												)
											}}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div class="col-md-12 mt-0 mb-0">
						<div class="row p-0 mb-0">
							<table class="table table-bordered mt-0 mb-0">
								<thead>
									<tr>
										<th colspan="2" scope="col" class="bg-dark">
											Application & Approval
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<!-- Field Name -->
										<td class="fw-bold">Application By:</td>
										<!-- Field Value -->
										<!-- this is a placeholder -->
										<td>{{ loan.created_by?.first_name }} {{ loan.created_by?.surname }}</td>
									</tr>
									<tr>
										<!-- Field Name -->
										<td class="fw-bold">
											Application Date:
										</td>
										<!-- Field Value -->
										<!-- this is a placeholder -->
										<td>{{ loan.created_at?.split('T')?.[0] ?? "" }}</td>
									</tr>
									<tr>
										<!-- Field Name -->
										<td class="fw-bold">Approvals:</td>
										<!-- Field Value -->
										<!-- this is a placeholder -->
										<td><a v-b-modal.view_history class="underline-none">View History</a></td>
									</tr>

								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
			<div class="col-3 col-md-3 akkurate-small">
				<div class="row h-100">
					<div class="col-md-12">
						<table class="table table-bordered">
							<thead>
								<tr class="bg-transparent">
									<th colspan="2" class="bg-transparent">
										Loan Details
									</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td class="fw-bold">Loan Code:</td>
									<td>
										{{ loan.loan_number }}
									</td>
								</tr>
								<tr>
									<td class="fw-bold">Last Payment Date:</td>
									<td>
										{{ loan.last_payment }}
									</td>
								</tr>
								<tr>
									<td class="fw-bold">Delinquency:</td>
									<td>
										{{ loan.delinquent }}
									</td>
								</tr>
								<tr>
									<td class="fw-bold">
										Loan Processing Fees:
									</td>
									<td>
										{{ institution?.currency_code }}
										{{ displayNumber(loan?.lpf_value) }}
									</td>
								</tr>
								<tr>
									<td class="fw-bold">
										External Reference:
									</td>
									<td>
										{{ loan.external_reference }}
									</td>
								</tr>
								<tr>
									<td class="fw-bold">
										Automatic SetOff:
									</td>
									<td>
										{{ automaticSetOff }}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="col-md-12 mt-auto">
						<table class="table table-bordered mt-0 mb-0">
							<thead>
								<tr>
									<th colspan="2" scope="col">
										Member Account Balances
									</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td class="fw-bold">Current Value:</td>
									<td style="color: #018673 !important">
										{{ institution?.currency_code }}
										{{ displayNumber(getCurrentValue) }}
									</td>
								</tr>
								<tr>
									<td class="fw-bold">Loan Balance:</td>
									<td>
										{{ institution?.currency_code }}
										{{
											displayNumber(
												Number(getLoanBalance).toFixed(
													2
												)
											)
										}}
									</td>
								</tr>
								<tr>
									<td class="fw-bold">Share Bal:</td>
									<td>
										{{ institution?.currency_code }}
										{{
											displayNumber(
												Number(
													loan?.shares_account_balances
												).toFixed(2)
											)
										}}
									</td>
								</tr>
								<tr>
									<td class="fw-bold">Saving Bal:</td>
									<td>
										{{ institution?.currency_code }}
										{{
											displayNumber(
												Number(
													loan?.savings_account_balances
												).toFixed(2)
											)
										}}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>

			<div class="col-3 col-md-3 akkurate-small">
				<div class="row h-100">
					<div class="col-md-12">
						<div class="row">
							<!-- <BarChart :data="barData.datasets[0].data" :labels="barData.labels" :options="chartOptions"
								:height="491" :colors="barData?.colors" :chartLable="barData.datasets[0].label" /> -->
							<BarChart v-if="chartData.length" :labels="labels" :data="chartData" :height="491"
								chart-label="Loan Data" :colors="colors" />
						</div>
					</div>
				</div>
			</div>

			<b-modal id='view_history' size="xl">
				<template #modal-title>
					<p class="mb-0 small akkurate-green fw-bold">Approval History</p>
				</template>
				<div class="table_text_size">
					<b-table striped bordered responsive id="member-table" :items="loan.approvals_history"
						:fields="history_fields" show-empty>
						<template #table-busy>
							<div class="text-center text-danger my-2">
								<b-spinner class="align-middle"></b-spinner>
								<strong>Loading...</strong>
							</div>
						</template>
						<template #empty="scope">
							<h4 class="text-center small mt-3">{{ scope.emptyText }}</h4>
						</template>

						<template #cell(index)="data">
							{{ data.index + 1 }}
						</template>
						<template #cell(approved_by)="data">
							<div>{{ data.item.approved_by ? `${data.item.approved_by?.first_name}
								${data.item.approved_by?.surname} - ${data.item.approved_by?.id}` : "" }}</div>
						</template>

						<template #cell(created_at)="data">
							<div>{{ formatDateAndTime(data.item.created_at) }}</div>
						</template>
					</b-table>
				</div>
				<template #modal-footer>
					<div class="w-100">
						<!-- Emulate built in modal footer ok and cancel button actions -->
						<b-button @click="$bvModal.hide('view_history')" type="submit"
							class="akkurate-grey me-2 btn-size float-right"><font-awesome-icon class="me-2"
								:icon="['fas', 'close']" />Close</b-button>
					</div>
				</template>
			</b-modal>
		</div>
	</div>
</template>
<script>
import BarChart from "../../../../components/Charts/BarChart.vue";
export default {
	props: ["loan", "institution"],
	components: {
		BarChart,
	},
	data() {
		return {
			labels: [
				"Principal Disbursed",
				"Principal Paid",
				"Principal Balance",
				"Interest Expected",
				"Interest Paid",
				"Interest Balance",
			],
			colors: [
				"#2a454e",
				"#018673",
				"#dc3545",
				"#2a454e",
				"#018673",
				"#dc3545",
			],
			history_fields: [
				{
					label: '#',
					key: 'index',
				},
				{
					label: 'Status',
					key: 'approval.loan_status',
				},
				{
					label: 'Stage',
					key: 'approval.name',
				},
				{
					label: 'Approved By',
					key: 'approved_by',
				},
				{
					label: 'Date and Time',
					key: 'created_at',
				},
			]
		};
	},
	computed: {
		chartData() {
			// Check for a valid loan object (adjust the property as needed)
			if (this.loan && this.loan.id) {
				return [
					Number(this.loan.principal_amount) || 0,
					Number(this.loan.principal_paid) || 0,
					Number(this.loan.principal_balance) || 0,
					Number(this.loan.expected_interest) || 0,
					Number(this.loan.interest_paid) || 0,
					Number(this.loan.interest_balance) || 0,
				];
			}
			// Return empty array if not ready
			return [];
		},
		automaticSetOff() {
			if (this.loan.automatic_set_off == 0) {
				return "No"
			}
			return "Yes";
		},
		getFullName() {
			// console.log(this.loan.approvals_history)
			const first_name =
				this.loan.account.customer.first_name != undefined
					? this.loan.account.customer.first_name
					: "";
			const middle_name =
				this.loan.account.customer.middle_name != undefined
					? this.loan.account.customer.middle_name
					: "";
			const last_name =
				this.loan.account.customer.last_name != undefined
					? this.loan.account.customer.last_name
					: "";
			return first_name + " " + middle_name + " " + last_name;
		},
		getDuePayment() {
			const payment =
				Number(this.loan?.interest_due ?? 0) +
				Number(this.loan?.principal_due ?? 0);
			return payment.toFixed(2);
		},
		getCurrentValue() {
			const current =
				Number(this.loan?.principal_balance ?? 0) +
				Number(this.loan?.interest_due ?? 0);
			return current.toFixed(2);
		},
		getLoanBalance() {
			const balance =
				Number(this.loan?.interest_balance ?? 0) +
				Number(this.loan?.principal_balance ?? 0);
			return balance.toFixed(2);
		},
		getBranch() {
			const branch = this.loan?.account?.customer?.branch?.name
				? this.loan?.account?.customer?.branch?.name
				: "";
			return branch;
		},
		total_credit() {
			return this.entries_items
				.filter(
					(trans) => trans.transaction_type == "Loan Repayment"
				)
				.reduce((total, trans) => total + trans.trans_amount, 0);
		},
		total_debit() {
			return this.entries_items
				.filter(
					(trans) => trans.transaction_type != "Loan Repayment"
				)
				.reduce((total, trans) => total + trans.trans_amount, 0);
		},
		total_principal() {
			return this.entries_items.reduce(
				(total, trans) => total + trans.principal,
				0
			);
		},
		total_interest() {
			return this.entries_items.reduce(
				(total, trans) => total + trans.interest,
				0
			);
		},
	},
	methods: {
		// rowClass(item, type) {
		// 	if (item?.get_pending_request_member_edit.length > 0) {
		// 		return 'custom-row-height table-custom-light-green'
		// 	} else {
		// 		return 'custom-row-height'
		// 	}

		// },
	}
};
</script>
